import { DestroyRef, Directive, inject, TemplateRef } from '@angular/core';
import { DetailDrawerFrame } from './detail-drawer-frame.service';

/**
 * Marks the item's footer — stepping to the previous or the next item — for the drawer to pin
 * below its content:
 *
 * ```html
 * @if (nextID()) {
 *   <ng-template lpDetailDrawerFooter><dm-button …>Nächste</dm-button></ng-template>
 * }
 * ```
 *
 * The drawer shows a footer only while an item provides one, so a conditional footer comes and
 * goes with its `@if`. The template keeps the item's own bindings and styles; only where it
 * renders moves.
 */
@Directive({ selector: 'ng-template[lpDetailDrawerFooter]' })
export class DetailDrawerFooterDirective {
  private readonly frame = inject(DetailDrawerFrame);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);

  constructor() {
    this.frame.showFooter(this.templateRef);
    inject(DestroyRef).onDestroy(() => this.frame.clearFooter(this.templateRef));
  }
}
